module.exports = __webpack_public_path__ + "static/media/naka-itabashi-5.53d28dae.jpg";